/* tslint:disable:import-spacing no-trailing-whitespace no-inferrable-types */
import {
  Component,
  ElementRef,
  Input,
  OnInit,
  OnDestroy
}                                      from '@angular/core';

import { Dialog                      } from '@/gui/dialogs/dialog';
import { NewProjectDialog            } from '@/gui/dialogs/new.project.dialog';
import { OpenProjectDialog           } from '@/gui/dialogs/open.project.dialog';
import { CloneProjectDialog          } from '@/gui/dialogs/clone.project.dialog';
import { NewSimulationDialog         } from '@/gui/dialogs/new.simulation.dialog';
import { NewLocomotiveModelDialog    } from '@/gui/dialogs/new.locomotive.model.dialog';
import { NewOperationalMeasureDialog } from '@/gui/dialogs/new.operational.measure.dialog';
import { BatchRegressionDialog       } from '@/gui/dialogs/batch.regression.dialog';
import { RenameElementDialog         } from '@/gui/dialogs/rename.element.dialog';
import { SaveBlobAsDialog            } from '@/gui/dialogs/save.blob.as.dialog';
import { NewDimensionDialog          } from '@/gui/dialogs/new.dimension.dialog';
import { NewEmptyBlobDialog          } from '@/gui/dialogs/new.empty.blob.dialog';
import { AddBlobUploadDialog         } from '@/gui/dialogs/add.blob.upload.dialog';
import { AddBlobDialog               } from '@/gui/dialogs/add.blob.dialog';
import { NewFolderDialog             } from '@/gui/dialogs/new.folder.dialog';
import { ErrorDialog                 } from '@/gui/dialogs/error.dialog';
import { NewCorridorBatchDialog      } from "@/gui/dialogs/new.corridor.batch.dialog";
import { NewBatchSummaryDialog       } from "@/gui/dialogs/new.batch.summary.dialog";
import { Logger                      } from '@/util/logger';
import { IValidatorCallBack          } from '@/gui/dialogs/i.validator.call.back';
import { IOkCallBack                 } from '@/gui/dialogs/i.ok.call.back';
import { SimDetailsDialog            } from '@/gui/dialogs/sim.details.dialog';
import { BlobHistoryDialog           } from '@/gui/dialogs/blob.history.dialog';
import { ServiceManager              } from '@/services/service.manager';

import * as $                          from 'jquery';
import 'jquery-ui-dist/jquery-ui';


@Component({
  selector: 'app-modal-dialog',
  template: `
      <div class="modal" role="dialog">
        <div class="modal-dialog {{modalsize}}">
        <div class="modal-content modal-wrapper">

          <div class="modal-header">
            <span class="modal-icon" [innerHTML]="icon"></span>
            <span class="modal-title" [innerHTML]="dialog.title"></span>
            <span  (click)="close();" class="modal-close"><i class="fas fa-times"></i></span>
          </div>

          <div class="modal-body">

            <p>
              Body Content "{{this.kind}}"
            </p>

          </div>

          <div class="modal-footer">

            <button *ngIf="hasOkButton()" class="gui-button modal-ok-button primary" (click)="ok();" >Ok</button>

            <button *ngIf="hasCancelButton()" class="gui-button" (click)="close();">Close</button>
          </div>
        </div>
        </div>
      </div>
      <div class="modal-background"></div>
`
})

/**
 *
 * @class ModalComponent
 *
 * @brief Angular adaptor for dialogs; it ties the template for each modal dialog
 * to an actual dialog controller, which can then do as it likes with the body
 * part of the dialog.
 *
 * Tutorial on custom modals in Angular:
 * @link https://stackblitz.com/edit/angular-6-custom-modal-dialog?file=app%2F_directives%2Fmodal.component.ts
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class ModalComponent implements OnInit, OnDestroy {

  /** the DOM #id */
  @Input()              modalsize: string = '';

  /** the DOM #id */
  @Input()              id: string;

  /** how the template tells us which dialog to use */
  @Input()            kind: string;

  /** header title */
  public             title: string = 'No Title';

  /** header icon */
  public              icon: string = '';

  /** the hosting DOM element */
  private readonly element: any;

  /** the dialog controller to use */
  public           dialog: Dialog = null;

  /** standard constructor */
  constructor(
    private services: ServiceManager,
    private           el: ElementRef
  ) {

    this.element = el.nativeElement;
  }

  hasOkButton(): boolean {

    if (!this.dialog) {
      return false;
    }

    return this.dialog.hasOk;
  }

  hasCancelButton(): boolean {

    if (!this.dialog) {
      return false;
    }

    return this.dialog.hasCancel;
  }

  ngOnInit(): void {

    Logger.debug(`[ModalComponent:${this.kind}] setting up, id:`, this.id);

    /* add a resize grip */

    setTimeout(() => {

      const m = this;
      const wrapper = $('#' + this.id).find('.modal-wrapper');

      if (m.modalsize === 'modal-lg') {

        $(wrapper).resizable({
          minWidth: 800,
          minHeight: 360,
        });

      } else {

        $(wrapper).resizable({
          minWidth: 500,
          minHeight: 360
        });
      }

    }, 50);

    /* ensure id attribute exists */

    if (!this.id) {

      Logger.error(`[ModalComponent:${this.kind}] missing #id: `, this);
      return;
    }

    /* which dialog controller do we use? */

    switch (this.kind) {

      case 'corridorbatch': {

        this.dialog = new NewCorridorBatchDialog(this.element, this.services);
        break;
      }

      case 'batchregression': {

        this.dialog = new BatchRegressionDialog(this.element);
        break;
      }

      case 'batchsummary': {

        this.dialog = new NewBatchSummaryDialog(this.element, this.services);
        break;
      }

      case 'blob-history': {

        this.dialog = new BlobHistoryDialog(this.element);
        break;
      }

      case 'sim-details': {

        this.dialog = new SimDetailsDialog(this.element, this.services);
        break;
      }

      case 'new-project': {

        this.dialog = new NewProjectDialog(this.element, this.services);
        break;
      }

      case 'clone-project': {

        this.dialog = new CloneProjectDialog(this.element, this.services);
        break;
      }

      case 'open-project': {

        this.dialog = new OpenProjectDialog(this.element, this.services);
        break;
      }

      case 'new-simulation': {

        this.dialog = new NewSimulationDialog(this.element);
        break;
      }

      case 'new-loco-model': {

        this.dialog = new NewLocomotiveModelDialog(this.element);
        break;
      }

      case 'new-opmeasure-model': {

        this.dialog = new NewOperationalMeasureDialog(this.element);
        break;
      }

      case 'rename-element': {

        this.dialog = new RenameElementDialog(this.element);
        break;
      }

      case 'saveblobas-element': {

        this.dialog = new SaveBlobAsDialog(this.element);
        break;
      }

      case 'new-dimension': {

        this.dialog = new NewDimensionDialog(this.element);
        break;
      }

      case 'new-empty-blob': {

        this.dialog = new NewEmptyBlobDialog(this.element);
        break;
      }
      case 'add-upload-blob': {

        this.dialog = new AddBlobUploadDialog(this.element);
        break;
      }
      case 'add-blob': {

        this.dialog = new AddBlobDialog(this.element, this.services);
        break;
      }

      case 'new-folder': {

        this.dialog = new NewFolderDialog(this.element);
        break;
      }

      case 'error-msg': {

        this.dialog = new ErrorDialog(this.element);
        break;
      }

      default: {

        Logger.error(`[ModalComponent:${this.kind}] unknown kind of dialog: `, this.kind);
        return ;
      }
    }

    this.title  = this.dialog.title;
    this.icon   = this.dialog.icon;

    const modal = this;

    /*
     * move element to bottom of page (just before </body>) so it can be displayed above
     * everything else
     */

    document.body.appendChild(this.element);

    /* close modal on background click */

    this.element.addEventListener('mousedown', (e: any) => {

      if (e.target.className === 'modal') {
        modal.close();
      }

    });

    /* add self to the modal service so it's accessible from anywhere */

    this.services.modals.add(this);
  }

  /* clean up on destruction of view */
  ngOnDestroy(): void {

    /* make this one sleep with the fishes */

    this.services.modals.remove(this.id);

    /* clean the DOM */

    this.element.remove();
  }

  /* open modal */
  open(validator?: IValidatorCallBack, success?: IOkCallBack, options?: any): void {

    /* tell the controller we're opening */

    if (this.dialog) {

      this.dialog.open(validator, success, options);
    }

    /* house keeping */

    this.element.style.display = 'block';
    document.body.classList.add('modal-open');
  }

  /* accept the modal */
  ok(): void {

    /* house keeping */

    this.element.style.display = 'none';
    document.body.classList.remove('modal-open');

    this.services.modals.dismissed();

    /* tell the controller we're closing */

    if (this.dialog) {

      this.dialog.ok();
    }

  }

  /* close the modal */
  close(): void {

    /* tell the controller we're closing */

    if (this.dialog) {

      this.dialog.close();
    }

    /* housekeeping */

    this.element.style.display = 'none';
    document.body.classList.remove('modal-open');

    this.services.modals.dismissed();
  }
}
